import AbstractBinaryOperatorFormulaNode from "./AbstractBinaryOperatorFormulaNode.js";

/**
 * `subtractionFormulaNode` is a concrete implementation
 * of `AbstractBinaryOperatorFormulaNode` representing a subtraction node.
 */
export default class SubtractionFormulaNode extends AbstractBinaryOperatorFormulaNode {
	accept(visitor, additionalInformation) {
		return visitor.visitSubtractionNode(this, additionalInformation);
	}

	getLabel() {
		return "-";
	}

	static getType() {
		return "SubtractionNode";
	}

	static precedence() {
		return this.additiveNodesPrecedence();
	}

	static build(builder, additionalInformation) {
		return builder.buildBinaryOperationNode(this, additionalInformation);
	}
}
